// Reminder window shown once after signing in
const loginReminders = {
  title: 'You have pending items',
  subtitle_one: 'There is one thing that needs your attention.',
  subtitle_other: 'There are {{count}} things that need your attention.',
  later: 'Later',
  sops: {
    title: 'Unread SOPs',
    description: 'SOPs you mark as read drop off this list.',
    action: 'Go to SOPs',
    more_one: '+{{count}} more SOP',
    more_other: '+{{count}} more SOPs',
  },
  docs: {
    title: 'Missing documents',
    description: 'You can upload them in the CV/GCP/IATA section of your profile.',
    action: 'Upload my documents',
    notUploaded: 'Not uploaded',
  },
  cargo: {
    title: 'You have shipments',
    description: 'Shipments not delivered yet. You can update their status in Profile › My Shipments.',
    action: 'Go to my shipments',
    more_one: '+{{count}} more shipment',
    more_other: '+{{count}} more shipments',
    overdue: 'Overdue',
    expected: 'Expected: {{date}}',
  },
};

export default loginReminders;
